import React, { useState } from 'react'
import { Container } from 'react-bootstrap'
import LeftHeading from '../../../../Components/Accounts/LeftHeading/LeftHeading'
import PaymentContainer from '../../../../Components/Accounts/Payments/PaymentContainer/PaymentContainer'
import PaymentMethodeManage from '../../../../Components/Accounts/Payments/PaymentMethodeManage/PaymentMethodeManage'
import PaymentTabs from '../../../../Components/Accounts/Payments/PaymentTabs/PaymentTabs'
import Tranjection from '../../../../Components/Accounts/Payments/Tranjection/Tranjection'
import TranjectionTab from '../../../../Components/Accounts/Payments/TranjectionTab/TranjectionTab'
import Section from '../../../../Components/Section/Section'
import { useEffect } from 'react'
import ErrorAlert from '../../../../Components/Form/ErrorAlert/ErrorAlert'
import { getResponseError, getUserDetailsCookie } from '../../../../Api/Utils/apiUtils'
import BuyerPaymentApi from '../../../../Api/BuyerPaymentApi'
import PaymentRequest from '../../../../Components/Accounts/Payments/PaymentRequest/PaymentRequest'
import PaymentSelect from '../../../../Components/Accounts/Payments/PaymentSelect/PaymentSelect'
import PayMoney from '../../../../Components/Accounts/Payments/PayMoney/PayMoney'



const ManageMemberPaymentComponent = () => {
    

    const [tabsActive, settabsActive] = useState(false)
    const [errorMessage, setErrorMessage] = useState(null);
    const [isCard, setisCard] = useState(true)// selected payment method that customer want to pay with
    const [isPayId, setisPayId] = useState(false)// same as upside
    const [isreadyForPayment, setisreadyForPayment] = useState(false)// same as upside
    const [paymentStatus, setpaymentStatus] = useState([])
    const [paymentRequests, setpaymentRequests] = useState([])
    const [isRequestExpand, setisRequestExpand] = useState({id: null, expand: false, supplierId: null, amount: null, businessId: null, purchaseId: null, paymentId: null, buyerId: null})
    

    function removeErrorMessage() {
        setTimeout(() => {
            setErrorMessage(null)
        }, 5000);
    }

    useEffect(() => {
        const user = getUserDetailsCookie()
        //payment status
        const loadPaymentStatus = async () => {
            const response = await BuyerPaymentApi.getBuyerPaymentStatus(user.id)
            const getResponseApiError = getResponseError(response)
            if (getResponseApiError) {
                setErrorMessage(getResponseApiError)
                removeErrorMessage()
            }else{
                const objvalue = response?.objectVal[0]
                const paymentstatusInfo = objvalue?.eventRequest?.objectVal
                setpaymentStatus(paymentstatusInfo)
            }
        }
        //payment requests
        const loadPaymentRequests = async () => {
            const response = await BuyerPaymentApi.getBuyerPaymentRequest(user.id)
            const getResponseApiError = getResponseError(response)
            if (getResponseApiError) {
                setErrorMessage(getResponseApiError)
                removeErrorMessage()
            }else{
                const requestinfo = response?.objectVal[0]
                const paymentRequestInfo = requestinfo?.eventRequest?.objectVal
                setpaymentRequests(paymentRequestInfo)
            }
        }
        loadPaymentRequests()
        loadPaymentStatus()
    }, [])



    return (
        <Section>
            <Container>
                <LeftHeading>Manage Payments</LeftHeading>
                <PaymentContainer>
                    {/* Tabs button */}
                    <PaymentTabs>
                        <div className={!tabsActive ? "active" : ""} onClick={() => settabsActive(false)}>Payment Requests</div>
                        <div className={ tabsActive? " active" : ""} onClick={() => settabsActive(true)}>Payment status</div>
                    </PaymentTabs>
                    {tabsActive ?
                    <TranjectionTab>
                        <ErrorAlert>{errorMessage}</ErrorAlert>
                        {paymentStatus && paymentStatus.length > 0 && 
                        paymentStatus.map((status, index) => (
                            <Tranjection key={index} paymentId={status.paymentId} clientId={status.productName} paymentStatus={status.paymentStatus} purchaseId={status.purchaseId} ammount={status.amount} isPaid={status.paymentStatus === "paid" ? true : false} label={"Product"}  />
                        ))
                        }
                    </TranjectionTab>
                    :
                    <>
                    <PaymentMethodeManage>
                        <ErrorAlert>{errorMessage}</ErrorAlert>
                        {isRequestExpand.expand ? 
                        <PaymentSelect setisreadyForPayment={setisreadyForPayment} isPayId={isPayId} setisPayId={setisPayId} isCard={isCard} setisCard={setisCard} iD={isRequestExpand.supplierId} expandDetails={isRequestExpand} setCancel={setisRequestExpand} />
                        :isreadyForPayment ?
                            <PayMoney isCard={isCard} isPayId={isPayId} paymentDetails={isRequestExpand} />
                        :
                        <div className="request-list">
                            {paymentRequests && paymentRequests.length > 0 && 
                            paymentRequests.map((request, i) => (
                                <PaymentRequest requestData={request} setisRequestExpand={setisRequestExpand} key={`REQUEST${i}`} avatar={request.SupplierImageUrl} name={request.businessName} productName={request.productName} email={request.SupplierEmailAddress} price={request.amount} />
                            ))}
                        </div>}
                    </PaymentMethodeManage>
                    </>
                    }
                </PaymentContainer>
            </Container>
        </Section>
    )
}

export default ManageMemberPaymentComponent
